export default "__VITE_ASSET__BhQmXE2p__"